import { useShallow } from "zustand/react/shallow";
import { RegulifyService } from "../api/RegulifyService";
import { useLoading } from "../context/LoadingContext";
import { useEUChangeManagementStore } from "../store/useEUChangeManagementStore";
import { questions } from "../utils/EUMDRQuestions";
import { useDownloadBase64File } from "./useDownloadBase64";

export function useEUChangeManagementFlow() {
  const newDecisionFlowItem = useEUChangeManagementStore(
    (state) => state.newDecisionFlowItem,
  );
  const setSelectedQuestion = useEUChangeManagementStore(
    (state) => state.setSelectedQuestion,
  );
  const removeDecisionFlowItem = useEUChangeManagementStore(
    (state) => state.removeDecisionFlowItem,
  );
  const resetDecisionFlowItem = useEUChangeManagementStore(
    (state) => state.resetDecisionFlowItem,
  );
  const newQuestionMessage = useEUChangeManagementStore(
    (state) => state.newQuestionMessage,
  );
  const selectedQuestion = useEUChangeManagementStore(
    useShallow((state) => state.selectedQuestion),
  );
  const downloadBase64File = useDownloadBase64File();

  const { setLoading } = useLoading();

  const answerQuestion = async (question) => {
    try {
      if (question.ask) {
        const userMessage = {
          text: question.ask,
          sender: "Human",
        };
        newQuestionMessage(userMessage);
      }
      setLoading(true);
      const response = await RegulifyService.start_eumdr_change_ctrl_decision_flow(
        question.question.code,
        question.answer,
        question.ask ? question.ask : "",
      );

      if (response.status === 201 && response.data) {
        if (response.data.next_question_id === "Finish") {
          downloadBase64File(
            "application/pdf",
            response.data.pdf_base64,
            "change_management.pdf",
          );
          resetDecisionFlowItem();
        } else {
          if (question.ask) {
            const botMessage = {
              text: response.data.llm_answer,
              sender: "Bot",
            };
            newQuestionMessage(botMessage);
          } else {
            setSelectedQuestion(
              questions.find(
                (item) => item.code === response.data.next_question_id,
              ),
            );
            newDecisionFlowItem({
              question: question.question,
              answer: question.answer,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };

  const undoAnswerQuestion = async (code) => {
    try {
      setLoading(true);
      const response = await RegulifyService.start_eumdr_change_ctrl_decision_flow(
        selectedQuestion.code,
        "back",
      );

      if (response.status === 201 && response.data) {
        removeDecisionFlowItem();
        setSelectedQuestion(
          questions.find(
            (item) => item.code === response.data.next_question_id,
          ),
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };

  const resetFlow = async (code) => {
    try {
      setLoading(true);
      const response =
        await RegulifyService.reset_eumdr_fdachange_ctrl_decision_flow();
      if (response.status === 201) {
        resetDecisionFlowItem();
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };
  return [answerQuestion, undoAnswerQuestion, resetFlow];
}
